<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import { userInfoAction } from '@/api/cp-action.js';
import axios from 'axios';
export default {
  name: 'app',
  data() {
    return {
      isRouterAlive: true
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  created() {
    // this.udc();
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      })
    },
    udc() {
      const userInfo = userInfoAction();
      Promise.all([userInfo.accountId(),userInfo.sessionId(),userInfo.deviceInfo()])
          .then(res=>{
              let account_id = res[0].data.account_id || -1;
              let session_id = res[1].data.session_id || -1;
              let device_id = res[2].data.device_no || -1;
              this.udcAjax({account_id,session_id,device_id});
          })
    },
    udcAjax(option) {
      const type = location.pathname.split('/')[1];
      axios({
            url:'/activity/api.php?m=public&subm=actstatistics',
            params: {
                ...this.$route.query,
                account_id: option.account_id,
                session_id: option.session_id,
                type
            },
            method: 'GET'
        })
        .then(res=>{
              if (res.data.code === 3001) {
                  const activityInfo = {
                    ...option,
                    ...res.data.data
                  }
                  udc.updateActivity(activityInfo);
                  udc.pageview();
              }
        })
        .catch(console.error)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  min-height: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue